<template>
    <!-- CancellationSearchItem.vue -->
    <base-search-item :to="cancellationUrl" v-bind="$props"></base-search-item>
</template>

<script>
    import {CANCELLATION_ICON} from '@/store/static/base-icons'
    import {CANCELLATION} from '@/router/cancellation/route-names'
    // Components
    import BaseSearchItem from './BaseSearchItem'

    export default {
        name: 'CancellationSearchItem',
        extends: BaseSearchItem,
        components: {
            BaseSearchItem
        },
        props: {
            /**
             * The icon of the list item
             */
            icon: {
                type: String,
                default: CANCELLATION_ICON
            }
        },
        computed: {
            cancellationUrl () {
                const vm = this
                return {
                    name: CANCELLATION,
                    params: {
                        cancellationId: vm.item.id
                    }
                }
            }
        }
    }
</script>
